import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { Reason } from '../../../../_models/reason';
import { ReasonType } from '../../../../_models/reason_type';
import { ReasonService } from '../../reason.service';

@Component({
  selector: 'app-reason',
  templateUrl: './reason-list.component.html',
  styleUrls: ['../../../master-page.css']
})
export class ReasonListComponent implements OnInit {
  searchForm: FormGroup;
  editorForm: FormGroup;
  rows: Reason[] = [];
  reasonTypes: ReasonType[] = [];
  selected: Reason = null;
  loading = false;
  saving = false;
  deleteModal = false;
  errorMessage = '';
  feedbackMessage = '';

  constructor(private formBuilder: FormBuilder, private reasonService: ReasonService) {}

  ngOnInit(): void {
    this.searchForm = this.formBuilder.group({ f_name: [''], f_type_reason: [''] });
    this.editorForm = this.formBuilder.group({
      id: [null],
      name: ['', [Validators.required, Validators.maxLength(255)]],
      type_id: [null, Validators.required],
      description: [''],
      text: [''],
      order: [0],
      active: [true]
    });
    this.loadTypes();
    this.loadRows();
  }

  loadTypes(): void {
    this.reasonService.getReasonTypes({}).subscribe(data => this.reasonTypes = data || []);
  }

  loadRows(): void {
    this.loading = true;
    this.errorMessage = '';
    this.reasonService.getReasons(this.searchForm.value).subscribe(data => {
      this.rows = data || [];
      this.loading = false;
    });
  }

  clearFilters(): void {
    this.searchForm.reset({ f_name: '', f_type_reason: '' });
    this.loadRows();
  }

  createNew(): void {
    this.selected = null;
    this.feedbackMessage = '';
    this.errorMessage = '';
    this.editorForm.reset({ id: null, name: '', type_id: null, description: '', text: '', order: this.nextOrder(), active: true });
  }

  editRow(rowIn: Reason): void {
    this.selected = rowIn;
    this.feedbackMessage = '';
    this.errorMessage = '';
    this.editorForm.reset({
      id: rowIn.id, name: rowIn.name || '', type_id: rowIn.type_id,
      description: rowIn.description || '', text: rowIn.text || '',
      order: Number(rowIn.order || 0), active: Number(rowIn.active) === 1
    });
  }

  saveRow(): void {
    if (this.saving) return;
    if (this.editorForm.invalid) {
      this.errorMessage = 'Indica el nombre y el tipo del motivo.';
      return;
    }
    const raw = this.editorForm.value;
    const payload = Object.assign({}, this.selected || {}, raw, {
      name: (raw.name || '').trim(),
      type_id: Number(raw.type_id),
      order: Number(raw.order || 0),
      active: raw.active === true ? 1 : 0
    }) as Reason;
    this.saving = true;
    this.errorMessage = '';
    this.feedbackMessage = '';
    const request = payload.id ? this.reasonService.updateReason(payload) : this.reasonService.createReason(payload);
    request.subscribe(data => {
      this.saving = false;
      if (!data) { this.errorMessage = 'No se ha podido guardar el motivo.'; return; }
      this.editRow(data);
      this.feedbackMessage = 'Motivo guardado correctamente.';
      this.loadRows();
    });
  }

  askDelete(rowIn: Reason): void { this.selected = rowIn; this.deleteModal = true; }

  confirmDelete(): void {
    if (!this.selected) return;
    this.reasonService.deleteReason(this.selected).subscribe(result => {
      this.deleteModal = false;
      if (result === null || result === undefined) { this.errorMessage = 'No se ha podido eliminar el motivo.'; return; }
      this.createNew();
      this.feedbackMessage = 'Motivo eliminado correctamente.';
      this.loadRows();
    });
  }

  typeName(idIn: any): string {
    const found = this.reasonTypes.find(item => Number(item.id) === Number(idIn));
    return found ? found.name : 'Sin tipo';
  }

  private nextOrder(): number {
    return this.rows.reduce((max, item) => Math.max(max, Number(item.order || 0)), 0) + 1;
  }
}
